/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerGetInternalConversationHistoryQueryResponse, AiAgentV2ControllerGetInternalConversationHistoryPathParams, AiAgentV2ControllerGetInternalConversationHistoryQueryParams, AiAgentV2ControllerGetInternalConversationHistory400, AiAgentV2ControllerGetInternalConversationHistory401, AiAgentV2ControllerGetInternalConversationHistory403, AiAgentV2ControllerGetInternalConversationHistory404 } from "../../models/aiAgentV2Controller/AiAgentV2ControllerGetInternalConversationHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { aiAgentV2ControllerGetInternalConversationHistory } from "../../clients/ai-agent-v2Service/aiAgentV2ControllerGetInternalConversationHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const aiAgentV2ControllerGetInternalConversationHistoryQueryKey = (requestId: AiAgentV2ControllerGetInternalConversationHistoryPathParams["requestId"], params: AiAgentV2ControllerGetInternalConversationHistoryQueryParams = {}) => [{
  url: '/api/v1/ai-agent-v2/internal-history/:requestId',
  params: {
    requestId: requestId
  }
}, ...(params ? [params] : [])] as const;
export type AiAgentV2ControllerGetInternalConversationHistoryQueryKey = ReturnType<typeof aiAgentV2ControllerGetInternalConversationHistoryQueryKey>;
export function aiAgentV2ControllerGetInternalConversationHistoryQueryOptions(requestId: AiAgentV2ControllerGetInternalConversationHistoryPathParams["requestId"], params?: AiAgentV2ControllerGetInternalConversationHistoryQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = aiAgentV2ControllerGetInternalConversationHistoryQueryKey(requestId, params);
  return queryOptions<AiAgentV2ControllerGetInternalConversationHistoryQueryResponse, ResponseErrorConfig<AiAgentV2ControllerGetInternalConversationHistory400 | AiAgentV2ControllerGetInternalConversationHistory401 | AiAgentV2ControllerGetInternalConversationHistory403 | AiAgentV2ControllerGetInternalConversationHistory404>, AiAgentV2ControllerGetInternalConversationHistoryQueryResponse, typeof queryKey>({
    enabled: !!requestId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return aiAgentV2ControllerGetInternalConversationHistory(requestId, params, config);
    }
  });
}

/**
 * @description Returns the internal conversation history message for debugging and analysis. Requires System Administrator role.
 * @summary Get internal conversation history for a request (System Admin only)
 * {@link /api/v1/ai-agent-v2/internal-history/:requestId}
 */
export function useAiAgentV2ControllerGetInternalConversationHistory<TData = AiAgentV2ControllerGetInternalConversationHistoryQueryResponse, TQueryData = AiAgentV2ControllerGetInternalConversationHistoryQueryResponse, TQueryKey extends QueryKey = AiAgentV2ControllerGetInternalConversationHistoryQueryKey>(requestId: AiAgentV2ControllerGetInternalConversationHistoryPathParams["requestId"], params?: AiAgentV2ControllerGetInternalConversationHistoryQueryParams, options: {
  query?: Partial<QueryObserverOptions<AiAgentV2ControllerGetInternalConversationHistoryQueryResponse, ResponseErrorConfig<AiAgentV2ControllerGetInternalConversationHistory400 | AiAgentV2ControllerGetInternalConversationHistory401 | AiAgentV2ControllerGetInternalConversationHistory403 | AiAgentV2ControllerGetInternalConversationHistory404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? aiAgentV2ControllerGetInternalConversationHistoryQueryKey(requestId, params);
  const query = useQuery({
    ...aiAgentV2ControllerGetInternalConversationHistoryQueryOptions(requestId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AiAgentV2ControllerGetInternalConversationHistory400 | AiAgentV2ControllerGetInternalConversationHistory401 | AiAgentV2ControllerGetInternalConversationHistory403 | AiAgentV2ControllerGetInternalConversationHistory404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}